export const dismissalTypeEnum = {
  UFAIR: "unfairDismissal",
  OBJECTIVE: "objectiveDismizssal",
  DISCIPLINARY: "disciplinaryDismissal"
};
